.page {
  color: #fff;
  :global {
    .ant-result-title,
    .ant-result-subtitle {
      color: #fff;
    }
  }
}
